import { render, staticRenderFns } from "./YearDetail.vue?vue&type=template&id=4e3dcba2"
import script from "./YearDetail.vue?vue&type=script&lang=js"
export * from "./YearDetail.vue?vue&type=script&lang=js"
import style0 from "./YearDetail.vue?vue&type=style&index=0&id=4e3dcba2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports